export default {
    path: "/system",
    name: "system",
    meta: {
        icon: "ios-settings",
        access: "menu_manage",
        title: "系统管理",
    },
    component: () => import("@/views/Main.vue"),
    children: [
        {
            path: "logs",
            meta: {
                icon: "ios-stats",
                access: "menu_manage_info",
                title: "信息",
            },
            component: () => import("@/views/parent-view.vue"),
            children: [
                {
                    path: "message",
                    name: "message",
                    meta: {
                        icon: "md-people",
                        access: "menu_manage_notice_info",
                        title: "公告信息",
                    },
                    component: () => import("@/views/system/message.vue"),
                },
                {
                    path: "commitlog",
                    name: "commitlog",
                    meta: {
                        icon: "md-people",
                        access: "menu_manage_handle_info",
                        title: "操作审计",
                    },
                    component: () => import("@/views/system/syslog.vue"),
                },
            ],
        },
        {
            path: "conf",
            meta: {
                icon: "ios-settings",
                access: "menu_manage_deploy",
                title: "基础配置",
            },
            component: () => import("@/views/parent-view.vue"),
            children: [
                {
                    path: "enterprise",
                    name: "enterprise",
                    meta: {
                        icon: "md-people",
                        access: "menu_manage_deploy_business",
                        title: "企业管理",
                    },
                    component: () => import("@/views/system/enterprise.vue"),
                },
                {
                    path: "worker",
                    name: "worker",
                    meta: {
                        icon: "md-people",
                        access: "menu_manage_deploy_worker",
                        title: "职员管理",
                    },
                    component: () => import("@/views/system/worker.vue"),
                },
                {
                    path: "roles",
                    name: "roles",
                    meta: {
                        icon: "md-contacts",
                        access: "menu_manage_deploy_role",
                        title: "角色&权限管理",
                    },
                    component: () => import("@/views/system/roles.vue"),
                },
                {
                    path: "posts",
                    name: "posts",
                    meta: {
                        icon: "ios-people",
                        access: "menu_manage_deploy_post",
                        title: "职务管理",
                    },
                    component: () => import("@/views/system/posts.vue"),
                },
                {
                    path: "department",
                    name: "department",
                    meta: {
                        icon: "logo-instagram",
                        access: "menu_manage_deploy_dep",
                        title: "部门管理",
                    },
                    component: () => import("@/views/system/department.vue"),
                },
                {
                    path: "resource",
                    name: "resource",
                    meta: {
                        icon: "md-bookmarks",
                        access: "menu_manage_deploy_res",
                        title: "资源管理",
                    },
                    component: () => import("@/views/system/resource.vue"),
                },
                {
                    path: "flowbill",
                    name: "flowbill",
                    meta: {
                        icon: "md-git-merge",
                        access: "menu_manage_deploy_flow",
                        title: "流程单据",
                    },
                    component: () => import("@/views/system/flowbill.vue"),
                },
                {
                    path: "workflow",
                    name: "workflow",
                    meta: {
                        icon: "md-git-merge",
                        access: "menu_manage_deploy_flow",
                        title: "流程定义",
                    },
                    component: () => import("@/views/system/workflow.vue"),
                },
                {
                    path: "workflow-add",
                    name: "workflow-add",
                    meta: {
                        hideInMenu: true,
                        icon: "md-git-merge",
                        access: "",
                        title: "创建新流程",
                    },
                    component: () =>
                        import(
                            "@/views/system/components/workflow/workflow-add.vue"
                        ),
                },
                {
                    path: "workflow-edit",
                    name: "workflow-edit",
                    meta: {
                        hideInMenu: true,
                        icon: "md-git-merge",
                        access: "",
                        title: "更新新流程",
                    },
                    component: () =>
                        import(
                            "@/views/system/components/workflow/workflow-edit.vue"
                        ),
                },
                {
                    path: "tags",
                    name: "tags",
                    meta: {
                        icon: "md-pricetags",
                        access: "menu_manage_deploy_label",
                        title: "标签管理",
                    },
                    component: () => import("@/views/system/tagmanage.vue"),
                },
                {
                    path: "status",
                    name: "status",
                    meta: {
                        icon: "ios-bookmark",
                        access: "menu_manage_deploy_state",
                        title: "状态管理",
                    },
                    component: () => import("@/views/system/status.vue"),
                },
                {
                    path: "taskflow",
                    name: "taskflow",
                    meta: {
                        icon: "ios-funnel",
                        access: "menu_manage_deploy_task",
                        title: "任务流程",
                    },
                    component: () => import("@/views/system/taskflow.vue"),
                },
                {
                    path: "repassword",
                    name: "repassword",
                    meta: {
                        hideInMenu: true,
                        icon: "ios-funnel",
                        access: "",
                        title: "重置密码",
                    },
                    component: () => import("@/views/system/repassword.vue"),
                },
            ],
        },
    ],
};
